<h3 mat-dialog-title>{{data.dialogTitle}}</h3>
<img (click)="closeDialog()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>
    <form [formGroup]="form">
        <div class="form-group">
            <label>
                Routing Number:
            </label>
            <input formControlName="routingNumber" class="form-control  form-control-sm" maxlength="9" required/>
        </div>

        <label>
            Account Number:
        </label>
        <input formControlName="accountNumber" class="form-control  form-control-sm" required/>
        
        <p class="text-danger" *ngIf="data.dialogError">
            {{data.dialogError}}
        </p>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button (click)="closeDialog()" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="handleBankInfo();" [disabled]="!form.valid"
            class="btn btn-primary"
            type="button">Next
    </button>
</mat-dialog-actions>
